import React from 'react';
import { Button } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Button';
import { Typography } from '@johnlewispartnership/wtr-ingredients/dist/foundations/typography';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/TextLink';

import FocusTrap from 'renderer/components/FocusTrap';
import urls from 'constants/urls';

import styles from '../CookieConsent.module.scss';

interface CookieInitialDecisionProps {
  acceptAll: () => void;
  rejectAll: () => void;
  viewPreferences: () => void;
}

export const CookieInitialDecision: React.FC<CookieInitialDecisionProps> = ({
  acceptAll,
  rejectAll,
  viewPreferences,
}) => (
  <FocusTrap
    active
    focusTrapOptions={{
      escapeDeactivates: false,
    }}
  >
    <section className={styles.banner} data-testid="initial-waitrose-cookie-consent-banner">
      <div className={styles.optionsContainer}>
        <Typography>
          Our website uses cookies to analyse traffic, personalise advertising and show you more of
          what you love. Please let us know you agree to all of our cookies. You can find out more
          on our{' '}
          <TextLink href={urls.waitroseCookies} className={styles.waitroseCookiesLink}>
            cookies policy
          </TextLink>{' '}
          page any time.
        </Typography>
      </div>
      <div className={styles.cookiesCTA}>
        <Button
          autoFocus
          data-testid="accept-all"
          data-webviewid="accept-cookies"
          type="button"
          width="standard"
          theme="primary"
          onClick={acceptAll}
          className={styles.acceptAll}
        >
          Allow all
        </Button>
        <Button
          data-testid="reject-all"
          data-webviewid="reject-cookies"
          type="button"
          width="standard"
          theme="secondary"
          onClick={rejectAll}
          className={styles.rejectAll}
        >
          Reject all
        </Button>
        <TextLink
          underline="always"
          className={styles.manageCookies}
          data-testid="manage-cookies"
          onClick={viewPreferences}
          component="button"
        >
          Manage cookies
        </TextLink>
      </div>
    </section>
  </FocusTrap>
);
